<template>
  <div class="border-t border-gray-700 p-2 space-y-1.5 shrink-0">
    <textarea
      :value="modelValue"
      class="w-full bg-gray-700 text-gray-100 text-xs rounded p-1.5 resize-none focus:outline-none focus:ring-1 focus:ring-blue-500"
      rows="2"
      placeholder="Commit message… (Ctrl+Enter)"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
      @keydown.ctrl.enter.prevent="$emit('commit')"
      @keydown.meta.enter.prevent="$emit('commit')"
    />
    <div class="flex gap-1">
      <button
        class="flex-1 text-xs bg-blue-600 hover:bg-blue-500 disabled:opacity-40 rounded py-1"
        :disabled="!modelValue.trim() || !stagedCount || busy"
        @click="$emit('commit')"
      >Commit staged</button>
      <button
        class="text-xs bg-gray-600 hover:bg-gray-500 disabled:opacity-40 rounded px-2"
        title="Stage all &amp; commit"
        :disabled="!modelValue.trim() || !totalCount || busy"
        @click="$emit('commitAll')"
      >All</button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue:  string
  stagedCount: number
  totalCount:  number
  busy:        boolean
}>()

defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'commit'): void
  (e: 'commitAll'): void
}>()
</script>
